var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useBuildStyleWithTheme } from '@cvent/carina-theme-provider';
import iconTypes from './StepIconTypes';
var buildStyle = function (_a, _b) {
    var backgroundColor = _a.backgroundColor, font = _a.font;
    var readingDirection = _b.readingDirection;
    return {
        wrapper: {
            display: 'flex',
            width: '100%'
        },
        main: {
            margin: '16px 0 0 30px',
            border: 'none',
            background: 'transparent',
            padding: '0',
            textAlign: 'left',
            fontSize: font.base.size.s,
            display: 'flex',
            flexGrow: 1,
            position: 'relative'
        },
        name: {
            base: __assign({ flexGrow: 1, fontFamily: font.base.family, pointerEvents: 'none', color: font.color.soft }, readingDirection),
            error: {
                color: font.color.danger.base
            },
            processing: {
                color: font.color.base
            },
            current: {
                color: font.color.base
            },
            hover: {
                color: 'rgb(74,80,89)'
            }
        },
        iconWrapper: {
            pointerEvents: 'none',
            color: font.color.danger.base
        },
        spacer: {
            base: {
                width: 4,
                height: 36,
                marginLeft: 10,
                backgroundColor: backgroundColor.interactive.active
            },
            completed: {
                backgroundColor: backgroundColor.accent.fill.base,
                '&::after': {
                    content: '" "',
                    height: 4,
                    width: 4,
                    marginTop: -1,
                    backgroundColor: backgroundColor.accent.fill.base,
                    display: 'block',
                    position: 'relative',
                    top: '100%',
                    borderBottomLeftRadius: '50%',
                    borderBottomRightRadius: '50%'
                }
            }
        },
        readingDirection: {
            spacer: {
                marginRight: 10
            },
            main: {
                textAlign: 'right',
                margin: '16px 14px 0 0'
            }
        }
    };
};
var useStyle = function (_a) {
    var isRtl = _a.isRtl, isCurrentSubStep = _a.isCurrentSubStep, status = _a.status, hover = _a.hover;
    var builtStyle = useBuildStyleWithTheme(buildStyle, { isRtl: isRtl });
    if (!builtStyle) {
        return {
            wrapper: {},
            main: {},
            name: {},
            iconWrapper: {},
            spacer: {}
        };
    }
    var wrapper = builtStyle.wrapper, main = builtStyle.main, name = builtStyle.name, iconWrapper = builtStyle.iconWrapper, spacer = builtStyle.spacer, readingDirection = builtStyle.readingDirection;
    return {
        wrapper: wrapper,
        main: __assign(__assign({}, main), (isRtl && readingDirection.main)),
        name: __assign(__assign(__assign(__assign(__assign({}, name.base), (status === iconTypes.error && name.error)), (status === iconTypes.processing && name.processing)), (isCurrentSubStep && name.current)), (hover && name.hover)),
        iconWrapper: iconWrapper,
        spacer: __assign(__assign(__assign({}, spacer.base), (status === iconTypes.completed && spacer.completed)), (isRtl && readingDirection.spacer))
    };
};
export default useStyle;
